/**
 * The customer-service WhatsApp line, mirrored from hanamaru
 * (`src/constants/common.ts` + `src/utils/helpers/contactHelper.ts`).
 *
 * hanamaru moved to 0819 3509 2014 on 1 Oct 2026 (d66f680eb) and this repo kept
 * printing 0817 7009 2014 in its footer, so the help center sent people to a
 * different line than the storefront header two clicks earlier. One constant,
 * used by every component here, is what keeps that from recurring.
 *
 * hanamaru gives partners their own line through the session; this app has no
 * partner session, so it always shows the general number.
 */
export const CS_PHONE = "6281935092014";

export const CS_EMAIL = "e-support@kyou.id";

/** The printed form, derived so the two shapes of the number cannot drift. */
export function getCsPhoneDisplay() {
  const local = CS_PHONE.replace(/^62/, "0");
  const groups = local.match(/.{1,4}/g);

  return groups === null ? local : groups.join(" ");
}

const DEFAULT_GREETING = "Aku datang dari Kyou.id dan butuh bantuan nih!";

/**
 * Same URL shape and default greeting as hanamaru's header and footer, so a
 * chat started here arrives looking like one started anywhere on the site.
 */
export function getCsWhatsAppUrl(text) {
  const message = encodeURIComponent(text || DEFAULT_GREETING);

  return `https://api.whatsapp.com/send/?phone=${CS_PHONE}&text=${message}&type=phone_number&app_absent=0`;
}
